// @flow

import gql from 'graphql-tag';

const serviceActionInfo = gql`
  fragment serviceActionInfo on ServiceAction {
    helpText
    helpTextHtml
    hide
    important
    key
    label
    noun
    needs
  }
`;

const serviceActionTypesInfo = gql`
  ${serviceActionInfo}

  fragment serviceActionTypesInfo on ServiceActionTypes {
    reads {
      helpText
      helpTextHtml
      hide
      important
      key
      label
      noun
      needs
      hookDirectionsHtml
      hookLegacyUrl
      hookUrl
      isHook
      isHookNotification
      isHookPollable
      isHookSubscription
      isHookToPoll
    }
    writes {
      ...serviceActionInfo
    }
    searches {
      ...serviceActionInfo
    }
    searchesOrWrites {
      helpText
      helpTextHtml
      hide
      important
      key
      label
      noun
      needs
      writeDelegate
      searchDelegate
    }
    filters {
      ...serviceActionInfo
    }
  }
`;

export default gql`
  ${serviceActionTypesInfo}

  fragment serviceActions on Service {
    actions {
      ...serviceActionTypesInfo
    }
  }
`;
